import React, { FC } from 'react';
import { InfoTooltip, Text } from '@tidbits/react-tidbits';

const SearchTooltip: FC = () => {
  return (
    <InfoTooltip>
      <InfoTooltip.Content>
        <Text>
          Use an asterisk (*) as a wildcard at the beginning or end of your search criteria to take
          the place of one or more characters in your search. (ie. App* will return results
          containing; App, Apple, Apps. *App will return results containing; happy, nappy, sappy)
        </Text>
      </InfoTooltip.Content>
    </InfoTooltip>
  );
};

export default SearchTooltip;
